const OrgInfoLead = ({ row, extraData }) => {
    const fiscalYear = row['devTags.FiscalYear'];
    const match = extraData['extraData.orgStaffProgress']?.find(
        item =>
            item.devTags?.FiscalYear === fiscalYear &&
            item.devTags.FiscalYear !== null &&
            item.devTags.FiscalYear !== undefined
    );
    // verify not null and not undefined before returning the value
    if (match && match !== null && match !== undefined) {
        return match.variables.org_PCANCname2;
    }
    return null;
};

export default OrgInfoLead;
